import React from 'react'
import { faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import ButtonIcon from 'components/ButtonComp';
import DrawerComp from 'components/Drawer'
import SelectComp from 'components/SelectComp'
import useForm from 'hooks/useForm';
import InputComp from 'components/InputComp';

type Props = {
    hookForm: ReturnType<typeof useForm>;
}

const FiltersComp: React.FC<Props> = ({
    hookForm
}: Props) => {
    const restoreFilters = () => {
        hookForm.setForm({
            deviceType: 'all',
            startDate: '',
            endDate: ''
        });
    }

    return (
        <DrawerComp
            title='Filtros'
            placement='right'
            type='button'
            variant='outline-primary'
        >

            <SelectComp
                className='mb-4'
                title='Tipo de Activo'
                name='deviceType'
                value={hookForm.form?.deviceType}
                options={[
                    { label: 'Todos', value: 'all' },
                    { label: 'Estaciones Meteorológicas', value: 'weather_station' },
                    { label: 'Paneles de Mensaje Variable', value: 'pmv' },
                    { label: 'Caḿaras CCTV', value: 'cctv' },
                ]}
                onChange={hookForm.handleChange}
            />
            <InputComp value={hookForm.form?.startDate} name='startDate' title='Fecha de inicio' type='date' onChange={hookForm.handleChange} /><br />
            <InputComp value={hookForm.form?.endDate} name='endDate' title='Fecha de fin' type='date' onChange={hookForm.handleChange} />
            <div className="d-grid mt-4">
                <ButtonIcon name='Limpiar Filtros' icon={faUndo} variant='outline-secondary' onClick={restoreFilters} />
            </div>
            <div className="d-grid gap-2 mt-2">
                <ButtonIcon name='Buscar' icon={faSearch} variant='success' onClick={hookForm.updateParams} />
            </div>
        </DrawerComp>
    )
}

export default FiltersComp